// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tasks-module__iconContract--hgOze>svg {
    color: #6F879C;
}

.Tasks-module__btnNavigation--ZUfGV {
    display: flex;
    justify-content: space-between;
    height: 40px;
    margin-top: 20px;
}
.Tasks-module__rightBtnNavigation--eh41n {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30px;
}
.Tasks-module__updateBtnBox--KDL9r {
    display: flex;
    justify-content: center;
    margin-top: 30px;
}
.Tasks-module__errorText--liIT1 {
    margin-top: 16px;
    color: red;
    font-size: 20px;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/tasks/Tasks.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB","sourcesContent":[".iconContract>svg {\r\n    color: #6F879C;\r\n}\r\n\r\n.btnNavigation {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    height: 40px;\r\n    margin-top: 20px;\r\n}\r\n.rightBtnNavigation {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 30px;\r\n}\r\n.updateBtnBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 30px;\r\n}\r\n.errorText {\r\n    margin-top: 16px;\r\n    color: red;\r\n    font-size: 20px;\r\n    text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconContract": `Tasks-module__iconContract--hgOze`,
	"btnNavigation": `Tasks-module__btnNavigation--ZUfGV`,
	"rightBtnNavigation": `Tasks-module__rightBtnNavigation--eh41n`,
	"updateBtnBox": `Tasks-module__updateBtnBox--KDL9r`,
	"errorText": `Tasks-module__errorText--liIT1`
};
export default ___CSS_LOADER_EXPORT___;
